import React, { memo, useState } from 'react';

import i18n from '@i18n';
import PopupNg from '@/ui/PopupNg';
import BellActiveIcon from '@/icons/BellActiveIcon';
import BellIcon from '@/icons/BellIcon';

import { Button } from 'nike-ui/src/components/button/Button';
import { notificationOnDeviceEnabled } from '@/notifications/web-notification-browser';
import useNotificationHandlerWrapper from '@/notifications/components/useNotificationHandlerWrapper';

/**
 * Tento komponent sluzi k prihlasovaniu a odhlasovaniu konkretneho tiketu z notifikacii pomocou ticketId.
 * Subscribed v tomto pripade oznacuje info o konkretnom tikete.
 */

function Notify({ subscribed, ticketId }) {
    const { browserSupported, withRegisteredNotif } = useNotificationHandlerWrapper();
    const [, repaint] = useState();
    const deviceEnabled = notificationOnDeviceEnabled();
    const icon = deviceEnabled && subscribed ? BellActiveIcon : BellIcon;
    const label =
        deviceEnabled && subscribed
            ? i18n('notifications.settings.notifiedTicket')
            : i18n('notifications.settings.notifyTicket');

    function onClick() {
        repaint();
        PopupNg.dispatcher.close('ticketDetail');
        PopupNg.dispatcher.close('betbook/ticketDetailPopup');
        PopupNg.dispatcher.open('ticket/notification', { ticketId });
    }
    return browserSupported ? (
        <Button
            className="blue"
            dataAtid="ticket-detail-follow"
            icon={icon}
            label={label}
            onClick={withRegisteredNotif(onClick)}
        />
    ) : null;
}

export default memo(Notify);
